var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from "react";
import { Alert, Snackbar } from "@mui/material";
export var SnackbarFeedback = function (_a) {
    var isOpen = _a.isOpen, type = _a.type, message = _a.message;
    var _b = useState(isOpen), open = _b[0], setOpen = _b[1];
    var handleClose = function (event, reason) {
        if (reason === "clickaway") {
            return;
        }
        setOpen(false);
    };
    return (_jsx(Snackbar, __assign({ open: open, autoHideDuration: 6000, onClose: handleClose, anchorOrigin: { vertical: "bottom", horizontal: "center" }, sx: { mb: "2rem" } }, { children: _jsx(Alert, __assign({ onClose: handleClose, severity: type, variant: "filled", sx: { width: "100%" } }, { children: message })) })));
};
